// routes.js
import Index from "views/Index.js";
import Profile from "views/Profile.js";
import Maps from "views/examples/Maps.js";
import Register from "views/Register.js";
import Login from "views/Login.js";
import Tables from "views/examples/Tables.js";
import Copy from "views/TableCopy.js";
import User from "views/TableUser";
import Device from "views/TableDevice.js";
import Schedules from "views/TableSchedules";
import Countries from "views/TableCountries";
import Icons from "views/examples/Icons.js";
import Groups from "views/TableGroups.js";
import PrivacyPolicy from "views/PrivacyPolicy.js";
import Shortener from "views/Shortener.js";
import AnalyticsReport from "views/AnalyticsReport.js";
import AnalyticsByDomain from "views/AnalyticsByDomain";
import AdManagerReport from "views/AdManagerReport.js";
import AdManagerKeyValueReport from "views/AdManagerKeyValueReport.js";
import ArbitragemComparativo from "views/ArbitragemComparativo.js";
import AdManagerDomainComparativo from "views/AdManagerDomainComparativo.js";
import GoogleAdsReport from "views/GoogleAdsReport.js";
import EmailMarketingReport from "views/EmailMarketingReport.js";
import RDStationReport from "views/RDStationReport.js";
import LeadsByDayReport from "views/LeadsByDayReport.js";

const routes = [
  {
    path: "/index",
    name: "Início",
    icon: "ni ni-tv-2 text-primary",
    element: <Index />, // ✅ ALTERADO
    layout: "/admin",
    showInSidebar: true,
  },

  {
    name: "WhatsApp",
    icon: "ni ni-send text-green",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/copy",
        name: "Textos",
        icon: "ni ni-book-bookmark text-blue",
        element: <Copy />, // ✅ ALTERADO
        layout: "/admin",
      },
      {
        path: "/schedules",
        name: "Horários",
        icon: "ni ni-bell-55 text-red",
        element: <Schedules />, // ✅ ALTERADO
        layout: "/admin",
      },
      {
        path: "/countries",
        name: "Países",
        icon: "ni ni-world text-info",
        element: <Countries />, // ✅ ALTERADO
        layout: "/admin",
      },
      {
        path: "/groups",
        name: "Grupos",
        icon: "ni ni-ungroup text-orange",
        element: <Groups />, // ✅ ALTERADO
        layout: "/admin",
      },
      {
        path: "/device",
        name: "Dispositivos",
        icon: "ni ni-mobile-button text-green",
        element: <Device />, // ✅ ALTERADO
        layout: "/admin",
      },
    ],
  },

  {
    name: "Analytics",
    icon: "ni ni-chart-bar-32 text-orange",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/analytics",
        name: "UTMs",
        icon: "ni ni-chart-pie-35 text-purple",
        element: <AnalyticsReport />,
        layout: "/admin",
      },
      {
        path: "/analytics-domain",
        name: "Domínios",
        icon: "ni ni-world-2 text-blue",
        element: <AnalyticsByDomain />,
        layout: "/admin",
      },
    ],
  },

  {
    name: "Google Ads",
    icon: "ni ni-money-coins text-red",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/google-ads",
        name: "Relatórios",
        icon: "ni ni-chart-bar-32 text-red",
        element: <GoogleAdsReport />,
        layout: "/admin",
      },
    ],
  },

  {
    name: "E-mail Marketing",
    icon: "ni ni-email-83 text-primary",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/email-marketing",
        name: "Relatório de Campanha AC",
        icon: "ni ni-chart-bar-32 text-primary",
        element: <EmailMarketingReport />,
        layout: "/admin",
      },

      {
        path: "/leads-by-day",
        name: "Leads por Dia",
        icon: "ni ni-calendar-grid-58 text-orange",
        element: <LeadsByDayReport />,
        layout: "/admin",
      },
      {
        path: "/rd-station",
        name: "Relatório de Campanha RD",
        icon: "ni ni-chart-bar-32 text-info",
        element: <RDStationReport />,
        layout: "/admin",
      },
    ],
  },

  {
    name: "Ad Manager",
    icon: "ni ni-money-coins text-success",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/admanager",
        name: "Relatórios",
        icon: "ni ni-chart-bar-32 text-success",
        element: <AdManagerReport />,
        layout: "/admin",
      },
      {
        path: "/admanager-keyvalue",
        name: "Key-Values",
        icon: "ni ni-tag text-teal",
        element: <AdManagerKeyValueReport />,
        layout: "/admin",
      },
    ],
  },

  {
    name: "Arbitragem",
    icon: "ni ni-chart-bar-32 text-yellow",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/arbitragem-comparativo",
        name: "Comparativo UTM",
        icon: "ni ni-collection text-yellow",
        element: <ArbitragemComparativo />, // ✅ nova página
        layout: "/admin",
      },
      {
        path: "/comparativo-dominios",
        name: "Comparativo de Domínios",
        icon: "ni ni-world text-yellow",
        element: <AdManagerDomainComparativo />,
        layout: "/admin",
      },
    ],
  },

  {
    name: "Gerenciamento",
    icon: "ni ni-settings-gear-65 text-info",
    collapse: true,
    showInSidebar: true,
    views: [
      {
        path: "/shortener",
        name: "Encurtador",
        icon: "ni ni-vector text-pink",
        element: <Shortener />, // ✅ ALTERADO
        layout: "/admin",
        showInSidebar: true,
      },
      {
        path: "/user",
        name: "Usuários",
        icon: "ni ni-single-02 text-yellow",
        element: <User />, // ✅ ALTERADO
        layout: "/admin",
      },
      {
        path: "/user-profile",
        name: "Perfil",
        icon: "ni ni-circle-08 text-primary",
        element: <Profile />, // ✅ ALTERADO
        layout: "/admin",
        showInSidebar: true,
      },
    ],
  },

  // EXEMPLOS ou TESTES
  {
    path: "/icons",
    name: "Ícones",
    icon: "ni ni-planet text-blue",
    element: <Icons />, // ✅ ALTERADO
    layout: "/admin",
    showInSidebar: false,
  },
  {
    path: "/maps",
    name: "Mapas",
    icon: "ni ni-pin-3 text-orange",
    element: <Maps />, // ✅ ALTERADO
    layout: "/admin",
    showInSidebar: false,
  },
  {
    path: "/tables",
    name: "Tabelas",
    icon: "ni ni-bullet-list-67 text-red",
    element: <Tables />, // ✅ ALTERADO
    layout: "/admin",
    showInSidebar: false,
  },

  // ROTAS DE AUTENTICAÇÃO
  {
    path: "/login",
    name: "Entrar",
    icon: "ni ni-key-25 text-info",
    element: <Login />, // ✅ ALTERADO
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/register",
    name: "Cadastro",
    icon: "ni ni-circle-08 text-pink",
    element: <Register />, // ✅ ALTERADO
    layout: "/auth",
    showInSidebar: false,
  },
  {
    path: "/privacypolicy",
    name: "Política de Privacidade",
    icon: "ni ni-lock-circle-open text-muted",
    element: <PrivacyPolicy />, // ✅ ALTERADO
    layout: "/auth",
    showInSidebar: false,
  },
];

export default routes;